<template>
  <Pdp
    :slug="slug"
  />
</template>

<script lang='ts'>
import { computed, defineComponent } from 'vue';

definePageMeta({
  layout: 'default-full-width',
  middleware: ['native-route-redirection'],
});

export default defineComponent({
  name: 'PdpSlug',
  setup () {

    const route = useRoute();
    const slug = computed(() => route.params?.slug);

    return {
      slug,
    };
  
  },
});

</script>
